import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XSwitch,
	XThemeContainer,
	XThemeDetailsCards,
	XThemeInputText,
	XThemeRadio,
	XThemeSwitchBtn,
	XThemeButton,
	XThemeTable,
	XThemeTag,
	XTag,
} from '../../../../styles/GlobalThemeStyle';
import {
	Row,
	Col,
	Button,
	Input,
	notification,
	Flex,
	Space,
	Table,
	Form,
} from 'antd';
import {
	XThemeTilesCard,
	XThemeVoiceAssCard,
	XThemeVoiceaAsistCard,
	XThemeVoiceAssSeeBtn,
	XThemeVoiceAssTable,
	XThemeVoiceAssTableCard,
	XThemeVoiceAssTitle,
	XThemeVoiceCreateCaseBtn,
	XThemeVoiceaAsistChartCard,
	XThemeVoiceaAssSearchBar,
	XThemeFitToScreen,
	XThemeFixBottom,
	XThemeVoiceaAsistChatCard,
	XThemeVACheckbox,
	XThemeVASubmitBTN,
	XVSLottie,
	XVSLottieWrapper,
	XThemeVSSetViewPort,
	XThemeVSScrollContainer,
	XThemeVSGenerateAL,
	XThemeHeaderBTN,
	XThemeVSDetailsCard,
	XThemeVSPara1,
	XThemeSentToTabs,
	XThemeVARadio,
	XThemeVAInputText,
	XThemeVATextArea,
	XThemeVSLottieThanks,
	XThemeVSAwaiting,
} from '../../VoiceAssistanceStyle';
import { CalendarOutlined, PlusCircleOutlined } from '@ant-design/icons';
import ThanksJson from '../../../../json/thanksNew1.json';

const VAAppealLetterSentLoader = (props) => {
	return (
		<>
			<XThemeVSSetViewPort className="displyBlock">
				<XThemeVSScrollContainer>
					<Row gutter={[15, 15]}>
						<Col xs={24} className="mb-3">
							<XThemeVoiceAssTitle>
								Appeal Letter
								<br />
								<span>Send To MD Advisor Or Coding Team</span>
							</XThemeVoiceAssTitle>
						</Col>
						<Col xs={24}>
							<XThemeVoiceAssTableCard>
								<div className="hasPadding">
									<Row
										gutter={[15, 15]}
										className="align-items-center"
									>
										<Col xs={24}>
											<XVSLottie
												className="relativePositions thanksJson"
												animationData={ThanksJson}
												loop={true}
											/>
										</Col>
										<Col xs={24}>
											<div className="thanksTitle">
												Appeal letter successfully
												<br />
												sent to team!
											</div>
										</Col>
									</Row>
									<Row className="my-4">
										<Col xs={24} className="text-center">
											<Space>
												{/* <XThemeVASubmitBTN size="large">
													Share Appeal Letter
												</XThemeVASubmitBTN> */}
												<XThemeVSAwaiting>
													<img
														className="img-fluid"
														src="/images/awaiting.svg"
														alt=""
													/>
													Awaiting for coding team to
													respond
												</XThemeVSAwaiting>
											</Space>
										</Col>
									</Row>
								</div>
							</XThemeVoiceAssTableCard>
						</Col>
					</Row>
				</XThemeVSScrollContainer>
			</XThemeVSSetViewPort>
		</>
	);
};

export default VAAppealLetterSentLoader;
